<template>
    <div  @click="handleClick" class="attachment-display" :title="props.data.filename" :style="[{width : clientWidth>767 ? '131px' : '169px'}]" :id="data.id">
        <ul class="d-flex position-ab hover_icon-slider z-index-1">
            <li>
                <a @click.stop.prevent="downloadAttachment(data)">
                    <img
                        src="@/assets/images/download_attchment.png"
                        alt=""
                    />
                </a>
            </li>
            <li v-if="isDelete">
                <a @click.stop.prevent="$emit('delete')">
                    <img
                        src="@/assets/images/delete_attechment.png"
                        alt=""
                    />
                </a>
            </li>
        </ul>
            <ImageIcon
                v-if="attachmentPath().startsWith('http')"
                :src="attachmentPath()"
                :alt="props.data.filename"
                :extension="props.data.extension"
            class="w-100"
                :style="[{height : clientWidth>767 ? '100px' : '120px',objectFit : 'contain'}]"
            />
        <WasabiIamgeCompp 
            v-else
            :data="data"
            class="attachment__image-height w-100"
            :style="[{height : clientWidth>767 ? '100px' : '120px'}]"
            :thumbnail="showThumbnails ? '130x93' : ''"
            @downloadUrl="(eve) => {downloadurl(eve)}"
        />
        <span class="attachment-filename-tooltip">{{ props.data.filename || props.data.name }}</span>
    </div>
    <SpinnerComp :is-spinner="isSpinner" v-if="isSpinner"/>
</template>

<script setup>
import WasabiIamgeCompp from "@/components/atom/WasabiIamgeCompp/WasabiIamgeCompp.vue"
import { defineComponent, defineProps, defineEmits, ref, inject, onMounted} from "vue";
import { download } from "@/utils/StorageOprations/download";
import SpinnerComp from '@/components/atom/SpinnerComp/SpinnerComp.vue';
import ImageIcon from "@/components/atom/ImageIcon/ImageIcon.vue"
import '@/components/atom/Attachments/styleAttachment.css';
import { storageHelper } from "@/composable/commonFunction";
import * as env from '@/config/env';


const {getStorageImage} = storageHelper();
const companyId = inject("$companyId");
// import Pdf from 'vue-pdf';
defineComponent({
    name: "AttchmentSingleComponent"
});

const emit = defineEmits(["delete", "click"]);

const props = defineProps({
    data: {
        type: Object,
        default: () => {}
    },
    isDelete: {
        type: Boolean,
        default: false
    },
    isSpinner: {
        type: Boolean
    }
});
const clientWidth = inject("$clientWidth");
const itemData = ref(props.data);
const showThumbnails =ref(false)
const downloadValue = ref('');

onMounted(() => {
    const fixedDate = new Date(2024,6,9).getTime();
    const today = new Date().setHours(0,0,0,0);
    showThumbnails.value = props.data.type === 'image' ? today >= fixedDate : false;
})

const attachmentPath = () => props.data.url || props.data.path || props.data.objectKey || props.data.object_key || '';

const downloadAttachment = async () => {
    const path = attachmentPath();
    if (!path) {
        console.error('Attachment path is missing.', props.data.id);
        return;
    }
    if(env.STORAGE_TYPE && env.STORAGE_TYPE == 'server') {
        const downloadUrl = downloadValue.value || props.data.downloadUrl || path;
        download(downloadUrl, props.data.name).catch((error) => {
            console.error('Error while downloading file.', error);
        });
        return;
    }
    try {
        const downloadUrl = downloadValue.value || (path.startsWith('http') ? path : await getStorageImage({
            companyId: companyId.value,
            data: { url: path },
        }));
        if (!downloadUrl) throw new Error('Download URL is unavailable');
        await download(downloadUrl, props.data.name || props.data.filename);
    } catch (error) {
        console.error("ERR: ", error);
    }
}

function downloadurl (e) {
    itemData.value.downloadUrl = e;
    downloadValue.value = e;
}
const handleClick = (event) => {
    event.stopPropagation();
    emit("click", props.data);
};
</script>
<style scoped>
.attachment-display {
    /* background-color: #e1dbdb; */
    margin-right: 10px;
    padding: 5px;
    border-radius: 6px;
    position: relative;
}
.attachment-display ul li {
    list-style: none;
    position: relative;
}
.attachment-display ul li img {
    background-color: #F4F5F7;
    height: 22px;
    border-radius: 2px;
    object-fit: contain;
    cursor: pointer;
}
.hover_icon-slider{
    gap: 5px;
    padding: 0;
    width: auto;
    right: 5px;
    top: 5px;
}
.attachment-filename-tooltip {
    position: absolute;
    left: 6px;
    right: 6px;
    bottom: 6px;
    z-index: 2;
    display: block;
    max-width: calc(100% - 12px);
    padding: 4px 6px;
    border-radius: 4px;
    background: rgba(23, 31, 42, 0.86);
    color: #fff;
    font-size: 11px;
    line-height: 15px;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
    text-overflow: ellipsis;
    visibility: hidden;
    white-space: nowrap;
}
.attachment-display:hover .attachment-filename-tooltip {
    opacity: 1;
    visibility: visible;
}
img.attachment__image-height {
    object-fit: contain;
}
@media(max-width: 767px){
    .attachment-display{  margin-right: 10px;padding: 0;width: 66px!important; 
        height: -webkit-fill-available;
    }
    img.attachment__image-height {
    object-fit: cover !important;
    border-radius: 8px;
}
}

</style>
